export default "__VITE_ASSET__70fdf3dc__"